module.exports = __webpack_public_path__ + "img/API-center.03e49ee4.png";